export const GOOGLE_CLIENT_ID = "453191268614-i3b184og7krvjg6tnbrtbdlb9jqifj4n.apps.googleusercontent.com";

export const SERVER_PUBLIC_KEY = process.env.REACT_APP_WAX_CHAIN === 'testnet'
    ? 'EOS5LYpwHomkLLuz4XZ4nfU65FAh1eWPEDHXS7zfAPLKmqf51maxg'
    : 'EOS5fL4GZYsNeT58CtFFxU6hc5tDVMjL1jEvB8Tuo8mTCjmckVrzu';

export const APTOS_SIGN_MESSAGE = 'Dark Country';